import type { PolicyArtefactType } from '@/lib/apiTypes'

export const SCOPE_PLURAL: Record<PolicyArtefactType, string> = {
  module: 'modules', state: 'state files', provider: 'providers', plan: 'plans',
}

/** Hover content for a policy's compliance: a high-level list of the non-compliant
 *  artefact names (per-version detail lives in the artefact's own pop-out modal). */
export function ComplianceTooltip({ total, failing, names, scope }: { total: number; failing: number; names?: string | null; scope: string }) {
  if (total === 0) return <span>No {scope} evaluated against this policy yet.</span>
  if (failing === 0) return <span>All {total} evaluated {scope} pass this policy.</span>
  const list  = (names ?? '').split(',').map((n) => n.trim()).filter(Boolean)
  const shown = list.slice(0, 15)
  const more  = list.length - shown.length
  return (
    <div style={{ display: 'grid', gap: 4, textAlign: 'left' }}>
      <div style={{ fontWeight: 600 }}>Non-compliant {scope}</div>
      <ul style={{ margin: 0, paddingLeft: 16, display: 'grid', gap: 2 }}>
        {shown.map((n) => <li key={n}>{n}</li>)}
      </ul>
      {more > 0 && <div className="dim">+{more} more</div>}
    </div>
  )
}

